import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";

function getHealableDrawingLinks(grp) {
  const locsByRecord = grp.locations.order.reduce((acc, id) => {
    const loc = grp.locations[id];
    if (!acc[loc.record_id]) {
      acc[loc.record_id] = [];
    }

    acc[loc.record_id].push(loc);
    return acc;
  }, {});

  const docs = grp.documents.order.reduce((acc, id) => {
    const doc = grp.documents[id];
    if (!doc.is_virtual) {
      doc.data.pages.order.forEach((pageId) => {
        const page = doc.data.pages[pageId];
        const [storedPageId, slug] = page.name.split("/");
        if (!acc[storedPageId]) {
          acc[storedPageId] = [];
        }
        acc[storedPageId].push({
          page,
          index: page.page,
          document_id: id,
        });
      });
    }

    return acc;
  }, {});

  const unlocatedItems = [];

  grp.items.order.forEach((id) => {
    const item = grp.items[id];
    if (item.drawing?.type !== "iiif") return false;
    const locs = locsByRecord[item.id] || [];

    const linkedLocation = locs.find(
      (l) => l.id === item.drawing.attachment_id,
    );
    const path = item.drawing.path.split("/");
    const [pageId, slug] = path;
    const [_, index] = slug.split(".");
    const pages = docs[pageId];
    const matchingPages =
      pages?.filter((p) => p.index === parseInt(index)) || [];

    const matchClip = locs.find((l) => {
      const mp = matchingPages.find((p) => p.page.id === l.page_id);
      return mp && isEqual(item.drawing.clip, l.clip);
    });

    if (!linkedLocation && matchClip) {
      const newDrawing = cloneDeep(item.drawing);
      newDrawing.attachment_id = matchClip.id;

      unlocatedItems.push({
        item,
        location: matchClip,
        drawing: newDrawing,
      });
    }
  });

  return { unlocatedItems };
}

function countHealableDrawingLinks(grp) {
  const { unlocatedItems } = getHealableDrawingLinks(grp);
  console.log(`${unlocatedItems.length} healable drawing links found.`);

  const table = [];
  unlocatedItems.forEach(({ item, location }) => {
    const doc = grp.documents[location.document_id];
    const index = doc.data.pages.indices[location.page_id];
    table.push({
      Mark: item.mark,
      ["Document name"]: doc.name,
      Page: index + 1,
    });
  });

  console.table(table);
}

function healDrawingLinks(grp) {
  const { unlocatedItems } = getHealableDrawingLinks(grp);
  const updates = unlocatedItems.map(({ item, drawing }) => {
    return { id: item.id, type: "item", prop: "drawing", value: drawing };
  });
  return updates;
}

export { countHealableDrawingLinks, healDrawingLinks };
